const logger = require('od-modules/utils/logger');
const EXCLUSION_LIST = [
    /TestError/,
    /^tman\.cgi/,
    /Script error/,
    /akamaihd/,
    /cloudfront\.net/,
    /__gCrWeb/,
    /DealPly/,
    /KDMScroller/,
    /_watcherReady/,
    /tv-classic-noboot-fg/,
    /evaluating 'window.parent.document'/,
    /top\.GLOBALS/,
    /fb_xd_fragment/,
    /bmi_SafeAddOnload/,
    /EBCallBackMessageReceived/,
    /conduitPage/,
    /originalCreateNotification/,
    /canvas\.contentDocument/,
    /Can't find variable: ZiteReader/,
    /jigsaw is not defined/,
    /ComboSearch is not defined/,
    /atomicFindClose/,
    // errors related with fetch (network error, error parsing the response...)
    /NetworkError/i,
    /failed to fetch/i,
    /The string did not match the expected pattern/i,
    /Unexpected end of JSON input/i,
];
const hasToSkipLogger = (msg, fileName, error) =>
    EXCLUSION_LIST.some((regex) =>
        Odigeo._.isEmpty(msg) || !(error instanceof Error) ||
        regex.test(msg) || regex.test(fileName) || regex.test(error.stack));

const cleanLog = (msg, params) =>
    params.filter(Boolean).length > 0 ? `${msg} -> ${params.join(':')}` : '';

const getErrorMessage = ({id, name}, {url, data}, status) => [
    cleanLog('Widget', [id, name]),
    cleanLog('Request url', [url]),
    cleanLog('Payload', [JSON.stringify(data)]),
    cleanLog('Status', status),
].filter(Boolean).join(', ');

window.onerror = (msg, fileName, lineNumber, column, error) => {
    if (!hasToSkipLogger(msg, fileName, error)) {
        logger.error(error, msg);
    }
};

window.onunhandledrejection = function onUnhandledRejection(e) {
    const error = e.reason;
    if (Odigeo.AB.isUnhandledRejectionLoggerActive && error instanceof Error) {
        window.StackTrace.fromError(error).then(([stackFrame]) => {
            if (!hasToSkipLogger(error.message, stackFrame.fileName, error)) {
                logger.error(error, error.message);
            }
        }).catch(() => {
            if (!hasToSkipLogger(error.message, null, error)) {
                logger.message(error.message);
            }
        });
    }
};

const BackboneOriginalSync = Backbone.sync;
Backbone.sync = function(method, model, options = {}) {
    const originalError = options.error;

    options.error = function(jqXHR, textStatus, errorThrown) {
        if (!options.silentLogger && errorThrown !== 'abort') {
            logger.message(getErrorMessage(model.widget || {}, options, [textStatus, errorThrown]));
        }
        if (Odigeo._.isFunction(originalError)) {
            originalError.apply(this, arguments);
        }
    };
    return BackboneOriginalSync.apply(this, arguments);
};
